export const SITE_PAGES_GRID = 'SitePagesGrid';

export const PAGE_CONTENT_STATUS__APPROVED = 'APPROVED';
export const PAGE_CONTENT_STATUS__CANCELED = 'CANCELED';
export const PAGE_CONTENT_STATUS__DELETED = 'DELETED';
export const PAGE_CONTENT_STATUS__PENDING = 'PENDING';

export const pageContentStatusLangKeys = {
  [PAGE_CONTENT_STATUS__APPROVED]: 'msg.approved',
  [PAGE_CONTENT_STATUS__CANCELED]: 'msg.canceled',
  [PAGE_CONTENT_STATUS__DELETED]: 'msg.deleted',
  [PAGE_CONTENT_STATUS__PENDING]: 'msg.pending',
};
